import { ref } from 'vue'

export function useSubmitOnce() {
  const inFlight = ref(false)

  const submitOnce = async work => {
    if (inFlight.value) return undefined
    inFlight.value = true
    try {
      return await work()
    } finally {
      inFlight.value = false
    }
  }

  return { inFlight, submitOnce }
}
